import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Radium, { Style } from 'radium';

import * as defaultStyles from '../../../styles';
import { request } from '../../../containers/actions';
import { host_v2 } from '../../../utilities/requests';

//Radium(SchoolReport);
export default class SchoolReport extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    constructor(props) {
        super(props);
        this.state = {
            taraz: null
        };
    }

    async componentDidMount() {
        if (this.props.school && this.props.examination && this.props.examination.id) {
            this.fetchReport.bind(this)();

            await this.getTaraz();
        }
    }

    async componentDidUpdate(prevProps, prevState) {
        // debugger;
        if (prevProps.school !== this.props.school ||
            (prevProps.examination && prevProps.examination.id) !==
            (this.props.examination && this.props.examination.id)) {
            this.fetchReport.bind(this)();
        }
        if (!prevState.print && this.state.print) {
            window.scrollTo(0, 0);
            window.print();
            this.setState({ print: false });
        }

        if (prevProps.school !== this.props.school)
            await this.getTaraz();
    }

    async fetchReport() {
        const school = this.props.school;
        if (!school || !this.props.examination || !this.props.examination.id) {
            this.setState({ data: undefined });
            return;
        }
        this.setState({ data: null });
        const response = await this.context.store.dispatch(request({
            path: `/examination/${this.props.examination.id}/report/school/school/`,
            body: { school },
        }));
        this.setState({
            data: response,
        });
        // if(this.props.examination.examination_type?.id !== 1 && this.props.examination.examination_type?.id !== 2){
        //     this.props.examination.participants = this.props.examination.participants_count;
        // }
    }
    excel() {
        var token = this.context.store.getState().get('application').get('token');
        var auth = token.get('accessToken');
        var url = host_v2 + "/ExportExcel/SchoolReport?authToken=" + auth + "&examId=" + this.props.examination.id
            + "&school=" + this.props.school;
        console.log(url, 'urlsss')
        window.open(url, '_blank');
    }
    getValueType1(material, field, group) {
        try {

            return this.state.data[material && material.id][field][group]
                ? this.state.data[material && material.id][field][group] < 0.01 ?Math.round(this.state.data[material && material.id][field][group]).toPercent().persian(true) : this.state.data[material && material.id][field][group].toPercent().persian(true)
                : '-';

        }
        catch (e) {
            return '-';
        }
    }

    async getTaraz() {
        if (!this.props.school) return;
        var token = this.context.store.getState().get('application').get('token');
        var auth = token.get('accessToken');
        var url = host_v2 + "/api/ReportSchoolApi/GetSchoolTarazInExams";

        const body = {
            ExamId: this.props.examination?.id,
            ExamTypeId: this.props.examination?.examination_type?.id,
            SchoolId: Number(this.props.school)
        };

        const response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                "authorization": auth,
                "content-type": "application/json"
            }
        })
        const data = await response.json();

        // if(data.error === 0)
        this.setState(e => ({ ...e, taraz: data?.result }))

    }

    render() {
        if (!this.state || !this.state.data)
            return null;
        var list = this.state.taraz || [];
        // for (var key in this.state.data) {
        //     if (typeof this.state.data[key] === "object") {
        //         list.push(this.state.data[key]);
        //     }
        // }
        // console.log(list, )
        let minimumTaraz = _.min(_.map(list, i => i?.value));
        let maximumTaraz = _.max(_.map(list, i => i?.value));
        console.log(list, 'examinations')
        if (maximumTaraz - minimumTaraz < 2000) {
            minimumTaraz = (minimumTaraz + maximumTaraz) / 2 - 1000;
            maximumTaraz = (minimumTaraz + maximumTaraz) / 2 + 1000;
        }
        minimumTaraz = Math.round(minimumTaraz / 500) * 500;
        maximumTaraz = Math.round(maximumTaraz / 500) * 500;
        // if (!this.state.data || this.state.data.global == null)
        //     return null;
        // const examinations = this.state.data.global.examinations;
        if (!this.state || !this.state.data)
            return null;
        // if (!_.includes(_.keys(this.state.data), '0'))
        //     return <div>{window.gettext('Please check again later!')}</div>;
        return <span>
            <div style={{ marginBottom: '.5em' }}>
                <button
                    key='print'
                    style={{ ...defaultStyles.defaultButton, backgroundColor: defaultStyles.fourthColor, float: 'left' }}
                    onClick={() => this.setState({ print: true })}>
                    {window.gettext('Print')}
                </button>&nbsp;
            </div>
            {this.state.data
                ? <span>
                    <div
                        style={{
                            ...defaultStyles.box,
                            width: '100%',
                            overflow: 'hidden',
                        }}>
                        <div style={{ float: 'right', width: '25%' }}>
                            {window.gettext('Examination')}: {this.props.examination.title}
                        </div>
                        <div style={{ float: 'right', width: '25%' }}>
                            {window.gettext('School Name')}: {this.state.data.school_display}
                        </div>
                        <div style={{ float: 'right', width: '25%' }}>
                            {window.gettext('City')}: {this.state.data.city_display}
                        </div>
                        <div style={{ float: 'right', width: '25%' }}>
                            {window.gettext('Grade')}: {this.state.data.grade_display}
                        </div>
                        <div style={{ float: 'right', width: '25%' }}>
                            {window.gettext('Holding Date')}: {this.props.examination.date ? this.props.examination.date.toJalali().persian() : ''}
                        </div>
                        <div style={{ float: 'right', width: '25%' }}>
                            {window.gettext('Analyze Date')}: {this.props.examination.analyze_date
                                ? this.props.examination.analyze_date.toJalali().persian()
                                : ''
                            }
                        </div>
                        <div style={{ float: 'right', width: '25%' }}>
                            {window.gettext('Centers Participated')}: {(this.state.data.centers || '').persian()}
                        </div>
                        <div style={{ float: 'right', width: '25%' }}>
                            {window.gettext('Participants')}: {(this.state.data.participants || '').persian()}
                        </div>
                        <div style={{ float: 'right', width: '25%' }}>
                            {"روش برگزاری"}: {(this.state.data.school_exam_was_paper > 0 &&
                                this.state.data.school_exam_was_online > 0 ?
                                ("آنلاین : " + (this.state.data.school_exam_was_online).persian() +
                                    " , کاغذی : " + (this.state.data.school_exam_was_paper).persian())
                                : (this.state.data.school_exam_was_paper > 0 ? ("کاغذی") : ("آنلاین ")))}
                        </div>
                        <div style={{ clear: 'right', textAlign: 'center', fontWeight: '700' }}>
                            {window.interpolate(
                                window.gettext('Ranks are based on %(analyzeModel)s!'),
                                { analyzeModel: this.props.examination.analyze_model === 1 ? window.gettext('Taraz') : window.gettext('Score') },
                                true,
                            )}
                        </div>
                    </div>
                    {this.state.print
                        ? <span style={{ display: 'block' }} class='media-print-display'>
                            <div
                                style={{
                                    position: 'fixed',
                                    top: '21mm',
                                    right: '61mm',
                                    width: '52mm',
                                    fontSize: '1.65em',
                                }}>
                                <div style={{ textAlign: 'center' }}>
                                    <b>{window.gettext('School Report')}</b>
                                </div>
                            </div>
                            <div
                                style={{
                                    position: 'fixed',
                                    top: '9mm',
                                    right: '127mm',
                                    width: '63.2mm',
                                }}>
                                <div style={{ overflow: 'hidden', height: '2.3em' }}>
                                    <b>{window.gettext('School Name')}:</b>&nbsp;
                                    {this.state.data.school_display} - {this.state.data.city_display}
                                </div>
                                <div style={{ overflow: 'hidden', height: '2.3em' }}>
                                    <b>{window.gettext('Examination')} - {window.gettext('Grade')}:</b>&nbsp;
                                    {this.props.examination.title} - {this.state.data.grade_display}
                                </div>
                            </div>
                            <div
                                style={{
                                    position: 'fixed',
                                    top: '9mm',
                                    right: '202mm',
                                    width: '42mm',
                                }}>
                                <div style={{ overflow: 'hidden', height: '2.3em' }}>
                                    <b>{window.gettext('Holding Date')}:</b> {this.props.examination.date
                                        ? this.props.examination.date.toJalali().persian()
                                        : ''
                                    }
                                </div>
                                <div style={{ overflow: 'hidden', height: '2.3em' }}>
                                    <b>{window.gettext('Participants')}:</b> {(this.state.data.participants || '').persian()}
                                </div>
                            </div>
                            <div
                                style={{
                                    position: 'fixed',
                                    top: '9mm',
                                    right: '254mm',
                                    width: '34mm',
                                }}>



                                <div style={{ overflow: 'hidden', height: '2.3em' }}>
                                    <b>{window.gettext('Centers Participated')}:</b> {(this.state.data.centers || '').persian()}
                                </div>
                                <div style={{ overflow: 'hidden', height: '2.3em' }}>
                                    <b>{window.gettext('Rank Among Schools')}:</b> {(this.state.data.school_rank || '').persian()}
                                </div>
                            </div>
                            <div
                                style={{
                                    position: 'fixed',
                                    top: '195mm',
                                    right: '16mm',
                                    width: '71mm',
                                }}>
                                <div style={{ overflow: 'hidden', height: '2.3em' }}>
                                    <b>{window.gettext('Analyze Date')}:</b> {this.props.examination.analyze_date
                                        ? this.props.examination.analyze_date.toJalali().persian()
                                        : ''
                                    }
                                </div>

                                <div style={{ marginTop: '10rem', width:'100%' }}>
                                    <svg
                                        style={{
                                            width: 'auto',
                                            height: '18em',
                                            overflow: 'visible',
                                            direction: 'ltr',
                                        }}
                                        viewBox={`0 -12 ${20 + (this.props.examination.materials.length + 1) * 30 + 20} 150`}
                                        preserveAspectRatio='none'>
                                        <text
                                            style={{ fill: '#00ff44' }}
                                            x={(this.props.examination.materials.length + 1) * 30}
                                            y='-12'
                                            dominantBaseline='hanging'
                                            textAnchor='start'
                                            fontSize='.6em'>
                                            {window.gettext('Global')}
                                        </text>,
                                        <text
                                            style={{ fill: '#7cd0eb' }}
                                            x={(this.props.examination.materials.length + 1) * 30 - 50}
                                            y='-12'
                                            dominantBaseline='hanging'
                                            textAnchor='start'
                                            fontSize='.6em'>
                                            {window.gettext('School')}
                                        </text>,
                                        {_.map(Array(6), (__, index) => [
                                            <text key={index + '-1'} x='18' y={index * 20} textAnchor='end' dominantBaseline='middle' fontSize='.6em'>
                                                ٪{index > 5 ? '-' : ''}{Math.abs((100 - index * 20)).persian()}
                                            </text>,
                                            <line key={index + '-2'} x1='19' y1={index * 20} x2='21' y2={index * 20} strokeWidth='1' stroke='black' />,
                                            <line
                                                key={index + '-3'}
                                                style={{
                                                    strokeWidth: '1',
                                                    stroke: 'rgba(0, 0, 0, .3)',
                                                    strokeDasharray: '1',
                                                }}
                                                x1='20'
                                                y1={index * 20}
                                                x2={(this.props.examination.materials.length + 1) * 30 + 20}
                                                y2={index * 20} />,
                                        ])}
                                        {_.map([...this.props.examination.materials, 0], (material, index) => [
                                            <text
                                                key={index}
                                                x={material.title?.length > 7?25 + 30 * index:30 + 30 * index }
                                                y='108'
                                                // transform={`rotate(60)`}
                                                textAnchor='start'
                                                fontSize='.25em'>
                                                {material === 0 ? window.gettext('All') : material.title}
                                            </text>,
                                            this.state.data[material && material.id]?.average.school >= 0
                                                ? <rect
                                                    style={{ fill: '#7cd0eb', stroke: 'black', strokeWidth: '.5' }}
                                                    key={material + '-school'}
                                                    x={25 + 30 * index}
                                                    y={100 - this.state.data[material && material.id].average.school * 100}
                                                    width={10}
                                                    height={this.state.data[material && material.id].average.school * 100} />
                                                : <rect
                                                    style={{ fill: '#7cd0eb', stroke: 'black', strokeWidth: '.5' }}
                                                    key={material + '-school'}
                                                    x={25 + 30 * index}
                                                    y={100}
                                                    width={10}
                                                    height={-this.state.data[material && material.id]?.average.school * 100} />,
                                            this.state.data[material && material.id]?.average.global >= 0
                                                ? <rect
                                                    style={{ fill: '#00ff44', stroke: 'black', strokeWidth: '.5' }}
                                                    key={material + '-global'}
                                                    x={35 + 30 * index}
                                                    y={100 - this.state.data[material && material.id]?.average.global * 100}
                                                    width={10}
                                                    height={this.state.data[material && material.id]?.average.global * 100} />
                                                : <rect
                                                    style={{ fill: '#00ff44', stroke: 'black', strokeWidth: '.5' }}
                                                    key={material + '-global'}
                                                    x={35 + 30 * index}
                                                    y={100}
                                                    width={10}
                                                    height={-this.state.data[material && material.id]?.average.global * 100} />,
                                        ])}
                                        <line x1='20' y1='-10' x2='20' y2='116' strokeWidth='1' stroke='black' />
                                        <line x1='20' y1='100' x2={(this.props.examination.materials.length + 1) * 30 + 20} y2='100' strokeWidth='1' stroke='black' />

                                    </svg>

                                    {this.state.taraz !== null && this.state.taraz?.length > 0
                                        ?
                                        <svg
                                            style={{
                                                float: 'right',
                                                width: 'auto',
                                                height: '20em',
                                                overflow: 'visible',
                                                direction: 'ltr',
                                                marginTop: "50px",
                                                margin:'0 auto'
                                            }}
                                            viewBox={`0 -12 ${20 + (list.length + 1) * 30 + 20} 150`}
                                            preserveAspectRatio='none'>
                                            {_.map(Array(6), (__, index) => [
                                                <text key={index + '-1'} x='18' y={index * 20} textAnchor='end' dominantBaseline='middle' fontSize='.6em'>
                                                    {(((index * minimumTaraz) +
                                                        ((5 - index) * maximumTaraz)) / 5).toFixed().persian()}
                                                </text>,
                                                <line key={index + '-2'} x1='19' y1={index * 20} x2='21' y2={index * 20} strokeWidth='1' stroke='black' />,
                                                <line
                                                    key={index + '-3'}
                                                    style={{
                                                        strokeWidth: '1',
                                                        stroke: 'rgba(0, 0, 0, .3)',
                                                        strokeDasharray: '1',
                                                    }}
                                                    x1='20'
                                                    y1={index * 20}
                                                    x2={(list.length + 1) * 30 + 20}
                                                    y2={index * 20} />,
                                            ])}
                                            {this.state.taraz?.map((item, index) => {
                                                const elements = [
                                                    <text
                                                        key={index}
                                                        x={35 + 30 * index}
                                                        y='108'
                                                        // transform={`rotate(60, ${35 + 30 * index}, 104)`}
                                                        textAnchor='end'
                                                        fontSize='.3em'
                                                        class='rtl-style'>
                                                        {item.title}
                                                        {/* {(title.substr(0, 14) + (title.length > 14 ? '...' : ''))} */}
                                                    </text>,
                                                ];
                                                elements.push(<circle
                                                    key={index + '-dot'}
                                                    cx={35 + 30 * index}
                                                    cy={100 - (item?.value - minimumTaraz) / (maximumTaraz - minimumTaraz) * 100}
                                                    r={2}
                                                    style={{ fill: '#7cd0eb' }} />);
                                                if (index < this.state.taraz.length - 1) {

                                                    // if (nextTaraz)
                                                    var nextTaraz = this.state.taraz[index + 1];
                                                    elements.push(<line
                                                        key={index + '-line'}
                                                        x1={35 + 30 * index}
                                                        y1={100 - (item?.value - minimumTaraz) / (maximumTaraz - minimumTaraz) * 100}
                                                        x2={35 + 30 * (index + 1)}
                                                        y2={100 - (nextTaraz?.value - minimumTaraz) / (maximumTaraz - minimumTaraz) * 100}
                                                        strokeWidth='1'
                                                        stroke='#7cd0eb'
                                                    />);
                                                }
                                                return elements;
                                            })}
                                            <line x1='20' y1='-10' x2='20' y2='116' strokeWidth='1' stroke='black' />
                                            <line
                                                x1='20'
                                                y1='100'
                                                x2={(list.length + 1) * 30 + 20}
                                                y2='100'
                                                strokeWidth='1'
                                                stroke='black' />
                                        </svg>
                                        : null
                                    }
                                </div>
                            </div>
                            <div
                                style={{
                                    position: 'fixed',
                                    top: '195mm',
                                    right: '120mm',
                                    fontSize: '1.3em',
                                    fontFamily: 'Arial',
                                }}>
                                <b>www.mhelli.ir</b>
                            </div>
                            <Style
                                rules={{
                                    '@page': {
                                        size: 'A4 Landscape',
                                        margin: '0',
                                    },
                                    mediaQueries: {
                                        print: {
                                            '*': {
                                                backgroundColor: 'unset !important',
                                            },
                                            body: {
                                                visibility: 'hidden',
                                            },
                                            '.page': {
                                                minHeight: 'unset',
                                            },
                                        },
                                    },
                                }}>
                            </Style>

                        </span>
                        : null
                    }
                </span>
                : null
            }
            <div
                style={{
                    '@media screen': {
                        ...defaultStyles.box,
                        marginTop: '1em',
                        height: "1300px"
                    }
                }}>
                <div style={{ display: this.state.print ? undefined : 'inline-block' }} class='media-print-display school-school-media-print'>
                    <button
                        style={{
                            ...defaultStyles.defaultButton,
                            padding: '.5em',
                            boxSizing: 'border-box',
                            marginBottom: '10px',
                            display: this.state.print ? 'none' : undefined,
                        }}
                        onClick={() => this.excel()}
                    >خروجی اکسل</button>
                    <table style={{
                        ...defaultStyles.table,
                    }}>
                        <thead style={{ backgroundColor: '#cccccc' }}>
                            <tr style={{ '@media print': { height: '34mm', border: 'none' } }} />
                            <tr>
                                <th rowSpan='2' style={{ ...defaultStyles.th, width: '12em' }}>
                                    {window.gettext('Material')}
                                </th>
                                <th rowSpan='2' style={{ ...defaultStyles.th, width: '4em' }}>
                                    {window.gettext('Taraz')}
                                </th>
                                <th rowSpan='2' style={{ ...defaultStyles.th, width: '3em' }}>
                                    {window.gettext('Rank')}
                                </th>
                                <th colSpan='3' style={{ ...defaultStyles.th, width: '12em' }}>
                                    {window.gettext('Average')}
                                </th>
                                <th colSpan='3' style={{ ...defaultStyles.th, width: '12em' }}>
                                    {window.gettext('Best')}
                                </th>
                            </tr>
                            <tr>
                                <th style={{ ...defaultStyles.th, width: '4em' }}>
                                    {window.gettext('School')}
                                </th>
                                <th style={{ ...defaultStyles.th, width: '4em' }}>
                                    {window.gettext('Region')}
                                </th>
                                <th style={{ ...defaultStyles.th, width: '4em' }}>
                                    {window.gettext('Global')}
                                </th>
                                <th style={{ ...defaultStyles.th, width: '4em' }}>
                                    {window.gettext('School')}
                                </th>
                                <th style={{ ...defaultStyles.th, width: '4em' }}>
                                    {window.gettext('Region')}
                                </th>
                                <th style={{ ...defaultStyles.th, width: '4em' }}>
                                    {window.gettext('Global')}
                                </th>
                            </tr>
                        </thead>
                        {_.map([...this.props.examination.materials, 0], material => <tr style={defaultStyles.th} key={material}>
                            <td style={{ ...defaultStyles.td, width: '12em', textAlign: 'right' }}>
                                {material === 0 ? window.gettext('All') : material.title.persian()}
                            </td>
                            <td style={{ ...defaultStyles.td, width: '4em', textAlign: 'center' }}>
                                {this.state.data[material && material.id]?.taraz?.school
                                    ? this.state.data[material && material.id].taraz?.school.toFixed().persian()
                                    : '-'
                                }
                            </td>
                            <td style={{ ...defaultStyles.td, width: '3em', textAlign: 'center' }}>
                                {this.state.data[material && material.id]?.rank?.school
                                    ? this.state.data[material && material.id].rank?.school.toFixed().persian()
                                    : '-'
                                }
                            </td>
                            {_.map(['average', 'best'], field => _.map(['school', 'region', 'global'], group => <td
                                key={field + '-' + group}
                                style={{ ...defaultStyles.td, width: '4em', textAlign: 'center' }}>
                                {this.getValueType1(material, field, group)}
                            </td>))}
                        </tr>)}
                        <tfoot>
                            <tr style={{ height: '26mm' }}></tr>
                        </tfoot>
                    </table>
                </div>
                <svg
                    style={{
                        width: 'auto',
                        height: '20em',
                        paddingTop: '3rem',
                        paddingBottom: '7rem',
                        overflow: 'visible',
                        direction: 'ltr',
                        display: this.state.print ? 'none' : undefined,
                    }}
                    viewBox={`0 -12 ${20 + (this.props.examination.materials.length + 1) * 30 + 20} 150`}
                    preserveAspectRatio='none'>
                    <text
                        style={{ fill: '#00ff44' }}
                        x={(this.props.examination.materials.length + 1) * 30}
                        y='-12'
                        dominantBaseline='hanging'
                        textAnchor='start'
                        fontSize='.6em'>
                        {window.gettext('Global')}
                    </text>,
                    <text
                        style={{ fill: '#7cd0eb' }}
                        x={(this.props.examination.materials.length + 1) * 30 - 50}
                        y='-12'
                        dominantBaseline='hanging'
                        textAnchor='start'
                        fontSize='.6em'>
                        {window.gettext('School')}
                    </text>,
                    {_.map(Array(6), (__, index) => [
                        <text key={index + '-1'} x='18' y={index * 20} textAnchor='end' dominantBaseline='middle' fontSize='.6em'>
                            ٪{index > 5 ? '-' : ''}{Math.abs((100 - index * 20)).persian()}
                        </text>,
                        <line key={index + '-2'} x1='19' y1={index * 20} x2='21' y2={index * 20} strokeWidth='1' stroke='black' />,
                        <line
                            key={index + '-3'}
                            style={{
                                strokeWidth: '1',
                                stroke: 'rgba(0, 0, 0, .3)',
                                strokeDasharray: '1',
                            }}
                            x1='20'
                            y1={index * 20}
                            x2={(this.props.examination.materials.length + 1) * 30 + 20}
                            y2={index * 20} />,
                    ])}
                    {_.map([...this.props.examination.materials, 0], (material, index) => [
                        <text
                            key={index}
                            x={35 + 30 * index}
                            y='104'
                            transform={`rotate(60, ${35 + 30 * index}, 104)`}
                            textAnchor='start'
                            fontSize='.6em'>
                            {material === 0 ? window.gettext('All') : material.title}
                        </text>,
                        this.state.data[material && material.id]?.average.school >= 0
                            ? <rect
                                style={{ fill: '#7cd0eb', stroke: 'black', strokeWidth: '.5' }}
                                key={material + '-school'}
                                x={25 + 30 * index}
                                y={100 - this.state.data[material && material.id].average.school * 100}
                                width={10}
                                height={this.state.data[material && material.id].average.school * 100} />
                            : <rect
                                style={{ fill: '#7cd0eb', stroke: 'black', strokeWidth: '.5' }}
                                key={material + '-school'}
                                x={25 + 30 * index}
                                y={100}
                                width={10}
                                height={-this.state.data[material && material.id]?.average.school * 100} />,
                        this.state.data[material && material.id]?.average.global >= 0
                            ? <rect
                                style={{ fill: '#00ff44', stroke: 'black', strokeWidth: '.5' }}
                                key={material + '-global'}
                                x={35 + 30 * index}
                                y={100 - this.state.data[material && material.id]?.average.global * 100}
                                width={10}
                                height={this.state.data[material && material.id]?.average.global * 100} />
                            : <rect
                                style={{ fill: '#00ff44', stroke: 'black', strokeWidth: '.5' }}
                                key={material + '-global'}
                                x={35 + 30 * index}
                                y={100}
                                width={10}
                                height={-this.state.data[material && material.id]?.average.global * 100} />,
                    ])}
                    <line x1='20' y1='-10' x2='20' y2='116' strokeWidth='1' stroke='black' />
                    <line x1='20' y1='100' x2={(this.props.examination.materials.length + 1) * 30 + 20} y2='100' strokeWidth='1' stroke='black' />

                </svg>

                {this.state.taraz !== null && this.state.taraz?.length > 0
                    ?
                    <svg
                        style={{
                            float: 'right',
                            width: 'auto',
                            height: '20em',
                            overflow: 'visible',
                            direction: 'ltr',
                            marginTop: "50px",
                        }}
                        viewBox={`0 -12 ${20 + (list.length + 1) * 30 + 20} 150`}
                        preserveAspectRatio='none'>
                        {_.map(Array(6), (__, index) => [
                            <text key={index + '-1'} x='18' y={index * 20} textAnchor='end' dominantBaseline='middle' fontSize='.6em'>
                                {(((index * minimumTaraz) +
                                    ((5 - index) * maximumTaraz)) / 5).toFixed().persian()}
                            </text>,
                            <line key={index + '-2'} x1='19' y1={index * 20} x2='21' y2={index * 20} strokeWidth='1' stroke='black' />,
                            <line
                                key={index + '-3'}
                                style={{
                                    strokeWidth: '1',
                                    stroke: 'rgba(0, 0, 0, .3)',
                                    strokeDasharray: '1',
                                }}
                                x1='20'
                                y1={index * 20}
                                x2={(list.length + 1) * 30 + 20}
                                y2={index * 20} />,
                        ])}
                        {this.state.taraz?.map((item, index) => {
                            const elements = [
                                <text
                                    key={index}
                                    x={35 + 30 * index}
                                    y='104'
                                    transform={`rotate(60, ${35 + 30 * index}, 104)`}
                                    textAnchor='end'
                                    fontSize='.4em'
                                    class='rtl-style'>
                                    {item.title}
                                    {/* {(title.substr(0, 14) + (title.length > 14 ? '...' : ''))} */}
                                </text>,
                            ];
                            elements.push(<circle
                                key={index + '-dot'}
                                cx={35 + 30 * index}
                                cy={100 - (item?.value - minimumTaraz) / (maximumTaraz - minimumTaraz) * 100}
                                r={2}
                                style={{ fill: '#7cd0eb' }} />);
                            if (index < this.state.taraz.length - 1) {

                                // if (nextTaraz)
                                var nextTaraz = this.state.taraz[index + 1];
                                elements.push(<line
                                    key={index + '-line'}
                                    x1={35 + 30 * index}
                                    y1={100 - (item?.value - minimumTaraz) / (maximumTaraz - minimumTaraz) * 100}
                                    x2={35 + 30 * (index + 1)}
                                    y2={100 - (nextTaraz?.value - minimumTaraz) / (maximumTaraz - minimumTaraz) * 100}
                                    strokeWidth='1'
                                    stroke='#7cd0eb'
                                />);
                            }
                            return elements;
                        })}
                        <line x1='20' y1='-10' x2='20' y2='116' strokeWidth='1' stroke='black' />
                        <line
                            x1='20'
                            y1='100'
                            x2={(list.length + 1) * 30 + 20}
                            y2='100'
                            strokeWidth='1'
                            stroke='black' />
                    </svg>
                    : null
                }
            </div>
        </span>;
    }
}
